/* Load Spotify only on request; native Shopify purchase controls remain authoritative. */
(()=>{
 document.addEventListener('click',event=>{
  const button=event.target.closest('.rl-load-spotify');
  if(!button)return;
  const mount=button.closest('.rl-spotify-mount');
  const id=mount.dataset.spotifyId;
  if(!/^[A-Za-z0-9]{22}$/.test(id))return;
  const target=mount.querySelector('.rl-spotify-target');
  if(target.querySelector('iframe'))return;
  const iframe=document.createElement('iframe');
  iframe.src='https://open.spotify.com/embed/album/'+id+'?utm_source=generator';
  iframe.title=mount.dataset.playerTitle;
  iframe.width='100%';iframe.height='352';iframe.style.border='0';iframe.style.borderRadius='12px';
  iframe.allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
  iframe.setAttribute('allowfullscreen','');
  target.append(iframe);button.hidden=true;target.hidden=false;
  iframe.focus();
 });
 const init=()=>{
  document.querySelectorAll('.rl-release-description').forEach(description=>{
   if(description.dataset.tracklistReady)return;
   const lines=description.innerText.split(/\n/).map(line=>line.replace(/\u00a0/g,' ').trim()).filter(Boolean);
   const records=lines.filter(line=>!/^track\s?list[: ]*$/i.test(line));
   if(records.length<2||!records.every(line=>/^[A-Z]\d+\s+\S/.test(line)))return;
   description.dataset.tracklistReady='true';
   const grid=document.createElement('div');grid.className='rl-track-sides';
   const groups=new Map();
   for(const line of records){
    const match=line.match(/^([A-Z])(\d+)\s+(.+)$/);
    if(!groups.has(match[1]))groups.set(match[1],[]);
    groups.get(match[1]).push({position:match[1]+match[2],name:match[3]});
   }
   for(const [side,tracks] of groups){
    const panel=document.createElement('section');panel.className='rl-track-side';
    const heading=document.createElement('h3');heading.textContent=(document.documentElement.lang.startsWith('fr')?'Face ':'Side ')+side;
    panel.append(heading);const list=document.createElement('ol');
    for(const track of tracks){const item=document.createElement('li');const number=document.createElement('span');number.textContent=track.position;const title=document.createElement('span');title.textContent=track.name;item.append(number,title);list.append(item);}
    panel.append(list);grid.append(panel);
   }
   description.replaceChildren(grid);
  });
  document.querySelectorAll('.rl-product-studio').forEach(root=>{
   const bar=root.querySelector('.rl-pocket-buy');
   const buy=root.querySelector('#AddToCart');
   if(!bar||!buy||bar.dataset.ready)return;
   bar.dataset.ready='true';
   let scheduled=false;
   // Phones only: show the bar while the main button is below the first screen or scrolled past, so price + add to cart stay reachable. Wider screens never show it.
   const update=()=>{scheduled=false;const current=root.querySelector('#AddToCart');const r=current&&current.getBoundingClientRect();const narrow=matchMedia('(max-width:700px)').matches;bar.classList.toggle('is-visible',narrow&&!!r&&(r.bottom<0||r.top>innerHeight));};
   const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update);}};
   window.addEventListener('scroll',schedule,{passive:true});
   window.addEventListener('resize',schedule,{passive:true});
   window.addEventListener('load',schedule,{once:true});
   window.addEventListener('hashchange',schedule);
   update();
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
